/**
 * Email notifications are not available (no Cloud Functions).
 * This module provides no-op stubs so the app runs without a paid backend.
 */

/** Email is not configured. */
export async function isEmailConfigured() {
  return false;
}

/** Returns status (email disabled). */
export async function getEmailStatusFull() {
  return {
    configured: false,
    overrideEnabled: false,
    overrideEmail: '',
    disabledOnFreePlan: true
  };
}

export function clearEmailConfiguredCache() {}

/** No-op on free plan. */
export async function saveSmtpConfig() {
  return;
}

/** No-op on free plan. */
export async function sendRegistrationConfirmation() {
  return;
}

/** No-op on free plan. */
export async function sendRegistrationPendingConfirmation() {
  return;
}

/** No-op on free plan. */
export async function notifyAdminsNewRegistration() {
  return;
}

/** No-op on free plan. */
export async function sendMatchSchedule() {
  return;
}

/** No-op on free plan. */
export async function sendMatchStarted() {
  return;
}

/** No-op on free plan. */
export async function sendMatchCompleted() {
  return;
}

/** No-op on free plan. */
export async function sendMatchUpdate() {
  return;
}

/** Not available. */
export async function sendCalendarInvites() {
  throw new Error('Calendar invites are not available.');
}
